import API from "@/package/config/axios";
import { IFeaturesFlagsResponse } from "@/package/global-types";

export const apiGetFeaturesFlags = () => {
  return API.get<IFeaturesFlagsResponse>("api/v1/client/features");
};
